import { IReaction } from "../../types/Ticket/IReaction";
import { Api } from "./BaseApi";

const reactionsApi = Api.injectEndpoints({
    endpoints: (builder) => ({
        getReactions: builder.query<IReaction[], number>({
            query: (id) => `Ticket/${id}/Reaction`,
            providesTags: ["GetReactions"],
        }),
        creatReaction: builder.mutation<any, IReaction>({
            query: (info) => ({
                url: `Ticket/${info.Call_Id}/Reaction`,
                method: "POST",
                body: info,
            }),
            invalidatesTags: ["GetReactions"],
        }),
        deleteReaction: builder.mutation<any, IReaction>({
            query: (reaction) => ({
                url: `Ticket/${reaction.Call_Id}/Reaction/${reaction.Id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['GetReactions'],
        }),
    }),
});

export default reactionsApi;